'use client';

import { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { useAuth } from '@/providers/auth-context';
import { API_BASE_URL } from '@/config/api';

export function useServiceVisibility() {
  const { authenticated } = useAuth();
  const [isStaff, setIsStaff] = useState(false);
  const [offeredIds, setOfferedIds] = useState<string[] | null>(null);
  const [activeIds, setActiveIds] = useState<string[]>([]);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const token = Cookies.get('token_access');
        const url = authenticated
          ? `${API_BASE_URL}/services-offered/my-services/`
          : `${API_BASE_URL}/services-offered/public-services/`;
        const res = await fetch(url, {
          credentials: authenticated ? 'include' : undefined,
          headers: authenticated && token ? { Authorization: `Bearer ${token}` } : undefined,
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();
        if (cancelled) return;
        const staff = authenticated && !!data?.is_staff;
        setIsStaff(staff);
        setOfferedIds(Array.isArray(data?.offered_tabs) ? data.offered_tabs : []);
        setActiveIds(authenticated && Array.isArray(data?.tabs) ? data.tabs : []);
      } catch {
        if (cancelled) return;
        setIsStaff(false);
        setOfferedIds([]);
        setActiveIds([]);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [authenticated]);

  const loaded = offeredIds !== null;
  const isOffered = (id: string) => isStaff || (offeredIds?.includes(id) ?? false);
  const hasAccess = (id: string) => authenticated && (isStaff || activeIds.includes(id));

  return { loaded, isStaff, offeredIds, activeIds, isOffered, hasAccess };
}
